import {SubForm} from 'Core/Screens/Forms/SubForm/SubForm';
import {AfterDropValidation} from "Core/Screens/DesignScreen/AfterDropValidation/AfterDropValidation";

export class PortletAfterDropValidation extends AfterDropValidation {
    IsPositionValid(item, sourceIndex, sourceItems, sourceContext, targetIndex, targetItems, targetContext): boolean {
        return !(targetContext instanceof SubForm) || targetIndex !== 0;
    }
}